import { connect } from 'react-redux';
import SignInPresentation from '../components/SignIn.js';
import { firebase } from '../firebase.js';

const createAccount = (email, password) => {
  firebase.auth().createUserWithEmailAndPassword(email, password).catch(function(error) {
    var errorCode = error.code;
    var errorMessage = error.message;
    console.log(errorMessage)
    console.log(errorCode)
  });
}

const login = (email, password) => {
  console.log('logging in')
  firebase.auth().signInWithEmailAndPassword(email, password).catch(function(error) {
    var errorCode = error.code;
    var errorMessage = error.message;
    console.log(errorMessage)
    console.log(errorCode)
  });
}

const mapStateToProps = state => {
  return {
    username: state.signIn.username,
    password: state.signIn.password,
    onCreateAccount: createAccount,
    onLogin: login,
  }
}

const mapDispatchToProps= dispatch => {
  return {
    onUsernameChange: (username) => {
      dispatch({
        type: 'USERNAME_CHANGE',
        username,
      })
    },
    onPasswordChange: (password) => {
      dispatch({
        type: 'PASSWORD_CHANGE',
        password,
      })
    }
  }
}

const SignIn = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignInPresentation)

export default SignIn



// WEBPACK FOOTER //
// ./src/containers/SignIn.js